import React, {FC} from 'react';
import styled from 'styled-components';

import {center} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

const StyledIconDiv = styled.div`
  grid-area: icon;
  ${center()};
`;

/*
 * Component.
 */

/** Icon for a P1 navigation line. */
export const NavigationLineIcon: FC = ({children}) => <StyledIconDiv>{children}</StyledIconDiv>;
